export default __webpack_public_path__ + "static/media/alphabet-yellow-at.ff541fb2.png";